import { AxiosResponse } from "axios"
import { T検索日種別コード } from "../../../constant/enum/frontend"

import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TBunkatuZyutuHaisyaPutReq,
  TBunkatuZyutyuHaisyaListGetReq,
  TBunkatuZyutyuHaisyaListGetRes,
  TBunkatuZyutyuHaisyaDeleteReq,
  TBunkatuZyutyuHaisyaGetRes,
  TBunkatuZyutuHaisyaPostReq,
} from "./TBunkatuZyutyuHaisya"

/**
 * 受注配車入力に対するAPIリクエスト用サービス
 *
 * @export
 * @class BunkatuZyutyuHaisyaService
 * @extends {ConnectApi}
 */
export default class BunkatuZyutyuHaisyaService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TBunkatuZyutyuHaisyaListGetReq} params
   * @memberof BunkatuZyutyuHaisyaService
   */
  getList = async <T extends T検索日種別コード>(
    params: TBunkatuZyutyuHaisyaListGetReq<T>
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TBunkatuZyutyuHaisyaListGetRes[]>> =
        await this.postInner(`/order/bunkatuzyutyuhaisya/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {number} id
   * @memberof BunkatuZyutyuHaisyaService
   */
  get = async (id: number) => {
    try {
      const res: AxiosResponse<TApiResponse<TBunkatuZyutyuHaisyaGetRes>> =
        await this.getInner(`/order/bunkatuzyutyuhaisya/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TBunkatuZyutuHaisyaPostReq} data
   * @memberof BunkatuZyutyuHaisyaService
   */
  post = async (data: TBunkatuZyutuHaisyaPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/order/bunkatuzyutyuhaisya`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TBunkatuZyutuHaisyaPutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof BunkatuZyutyuHaisyaService
   */
  put = async (id: number, data: TBunkatuZyutuHaisyaPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/order/bunkatuzyutyuhaisya/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {TMenuInfoGetReq} params
   * @memberof BunkatuZyutyuHaisyaService
   */
  delete = async (param: TBunkatuZyutyuHaisyaDeleteReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/order/bunkatuzyutyuhaisya/delete`,
        param
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
